import { toast } from "sonner";
import { handleTypeService } from "../Consts";

export type AppToastType = keyof typeof handleTypeService;

const SUCCESS_TYPES = new Set<AppToastType>([
  "success",
  "copySuccess",
  "resetSuccess",
]);

const TOAST_DURATION_MS = 3000;

export function showAppToast(type: AppToastType) {
  const { title, description } = handleTypeService[type];
  const options = {
    description: description || undefined,
    duration: TOAST_DURATION_MS,
  };

  if (SUCCESS_TYPES.has(type)) {
    toast.success(title, options);
  } else {
    toast.error(title, options);
  }
}
